import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';
import { faComment } from '@fortawesome/pro-light-svg-icons';
import { assessmentBadges } from '../Review/Badges';
import RinggoldBadge from '../RinggoldBadge';
import FileComponent from './FileComponent';
import AssessmentFeedbackAccordion from './AssessmentFeedbackAccordian';
import { useOptInsData } from 'src/pages/MyTask/Assessments/hooks';

interface Props {
  onClose: () => void;
  isOpen: boolean;
}

const ReviewFeedbackModal = ({ onClose, isOpen }: Props) => {
  const { earlyAssessment, workflowResponse } = useAssessmentData();

  const { config, isOptIns } = useOptInsData(workflowResponse, earlyAssessment.submissionContextId)
  const submissionScore = earlyAssessment?.caseData.assessment?.submissionScores;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="45rem"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <Flex flexDirection="column" gap={4}>
          <FontAwesomeIcon
            icon={faComment}
            style={{ width: '40px', height: '40px' }}
          />
          <Text textStyle="headingGroup">Review Feedback</Text>
          {earlyAssessment.caseData.assessment?.recommendation && (
            <Flex flexDirection="column" gap={3}>
              <Text textStyle="headingItem">Recommendation</Text>
              <Box>
                {
                  assessmentBadges[
                  earlyAssessment.caseData.assessment.recommendation
                  ]
                }
              </Box>
            </Flex>
          )}
        </Flex>
        {
          isOptIns && earlyAssessment?.caseData?.assessment && submissionScore ?
            <AssessmentFeedbackAccordion
              assessment={earlyAssessment?.caseData?.assessment}
              config={config}
              submissionScore={submissionScore}
            />
            :

            < Flex flexDirection="column" gap={6}>
              {(earlyAssessment.caseData.assessment?.feedbackForEditors ||
                (earlyAssessment.caseData.assessment?.editorAttachments && earlyAssessment.caseData.assessment?.editorAttachments?.length > 0) ||
                earlyAssessment.caseData.assessment?.recommendedReviewers?.exists) &&
                <>
                  <Text textStyle="headingGroup">Communications For Editors</Text>
                  {earlyAssessment.caseData.assessment?.feedbackForEditors &&
                    <Flex gap={3} direction={'column'}>
                      <Text textStyle="headingItem">Feedback for Editors</Text>
                      <Text textStyle="textBody">
                        {earlyAssessment.caseData.assessment?.feedbackForEditors}
                      </Text>
                    </Flex>}

                  {earlyAssessment.caseData.assessment?.editorAttachments && earlyAssessment.caseData.assessment?.editorAttachments?.length > 0 && (
                    <Flex flexDirection="column" gap={3}>
                      <Text textStyle={'headingItem'}>Attached Files</Text>
                      {earlyAssessment.caseData.assessment?.editorAttachments.map(file => (
                        <FileComponent file={file} />
                      ))}
                    </Flex>
                  )}
                  <Flex gap={3} direction={'column'}>
                    {earlyAssessment.caseData.assessment?.recommendedReviewers?.exists && (
                      <>
                        <Text textStyle="headingItem">Recommended Reviewers</Text>
                        {earlyAssessment.caseData.assessment?.recommendedReviewers?.value.map(
                          item => (
                            <Flex flexDirection="column" gap={2}>
                              <Text textStyle="headingItem">
                                {item.firstName} {item.lastName}
                              </Text>
                              <Flex gap={1} alignItems="center">
                                <Text
                                  noOfLines={1}
                                  overflow="hidden"
                                  textOverflow="ellipsis"
                                >
                                  {item.affiliation}
                                </Text>
                                {item.ringgoldId && <RinggoldBadge />}
                              </Flex>
                              <Text textStyle="textBody">{item.email}</Text>
                              <Text textStyle="textBody">{item.reason}</Text>
                            </Flex>
                          )
                        )}
                      </>
                    )}

                  </Flex>
                </>}
              {earlyAssessment.caseData.assessment?.feedbackForAuthors || (earlyAssessment.caseData.assessment?.authorsAttachments && earlyAssessment.caseData.assessment?.authorsAttachments?.length > 0) && (
                <>
                  <Text textStyle="headingGroup">Communications For Authors</Text>
                  {earlyAssessment.caseData.assessment?.feedbackForAuthors && <Flex gap={3} direction={'column'}>
                    <Text textStyle="headingItem">Feedback for Authors</Text>
                    <Text textStyle="textBody">
                      {earlyAssessment.caseData.assessment?.feedbackForAuthors}
                    </Text>
                  </Flex>}
                  {earlyAssessment.caseData.assessment?.authorsAttachments && earlyAssessment.caseData.assessment?.authorsAttachments?.length > 0 && (
                    <Flex flexDirection="column" gap={3}>
                      <Text textStyle={'headingItem'}>Attached Files</Text>
                      {earlyAssessment.caseData.assessment?.authorsAttachments.map(file => (
                        <FileComponent file={file} />
                      ))}
                    </Flex>
                  )}
                </>
              )}
            </Flex>
        }

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal >
  );
};

export default ReviewFeedbackModal;
